export default __webpack_public_path__ + "static/media/march2023-1.b0a3d6fb.jpg";